import {
  customInstance
} from "./chunk-PXAHF6KP.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// generated/search-bff/controllers/deprecated-listing-property-search/deprecated-listing-property-search.ts
var getAgent2 = (agentId, options) => {
  return customInstance(
    {
      url: `/api/v1/agent/${agentId}`,
      method: "GET"
    },
    options
  );
};

// src/services/getAgentById/getAgentById.ts
async function getAgentById(agentId, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getAgent2");
  try {
    const agent = await getAgent2(agentId, _apiConfig);
    return {
      status: "success",
      data: agent
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getAgentById
};
